import React, { Children } from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
const forWho = ['Women 40+ dealing with perimenopause or menopause night sweats.', 'Men 45+ experiencing the "wired-but-tired" symptoms of andropause.', 'High-performers whose heavy workload is being sabotaged by 3:00 AM brain fog.', 'Anyone who feels like they\'ve tried every pill and "sleep hack" with zero results.'];
const notForWho = ['People looking for a "magic pill" or pharmaceutical sedative.', 'Those unwilling to change their evening digital habits or bedroom temperature.', 'Children or young adults (this is specifically tuned for the 40+ hormonal profile).'];
export function Audience() {
  return <section className="py-24 md:py-32 bg-[#0B1029] relative" data-id="element-13">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-15">
          <FadeIn data-id="element-16">
            <div className="bg-white/[0.02] p-8 md:p-12 rounded-3xl border border-white/10 h-full" data-id="element-17">
              <h3 className="text-2xl md:text-3xl font-serif text-white mb-10 flex items-center gap-4" data-id="element-18">
                <div className="bg-green-500/10 text-green-400 p-3 rounded-full" data-id="element-19">
                  <Check className="w-6 h-6" data-id="element-20" />
                </div>
                Who This Is For
              </h3>
              <ul className="space-y-6" data-id="element-21">
                {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-22">
                    <div className="w-2 h-2 rounded-full bg-green-400 mt-2.5 shrink-0" data-id="element-23" />
                    <p className="text-slate-300 text-lg font-light leading-relaxed" data-id="element-24">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-25">
            <div className="bg-white/[0.02] p-8 md:p-12 rounded-3xl border border-white/10 h-full opacity-80" data-id="element-26">
              <h3 className="text-2xl md:text-3xl font-serif text-white mb-10 flex items-center gap-4" data-id="element-27">
                <div className="bg-red-500/10 text-red-400 p-3 rounded-full" data-id="element-28">
                  <X className="w-6 h-6" data-id="element-29" />
                </div>
                Who This Is NOT For
              </h3>
              <ul className="space-y-6" data-id="element-30">
                {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-31">
                    <div className="w-2 h-2 rounded-full bg-red-400 mt-2.5 shrink-0" data-id="element-32" />
                    <p className="text-slate-400 text-lg font-light leading-relaxed" data-id="element-33">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}